import { KlaviyoNewsletterPreferences } from './klaviyo-types'

export type NotificationMenuType = (typeof KlaviyoNewsletterPreferences)[keyof typeof KlaviyoNewsletterPreferences]

export type NotificationMenu = { name: string; value: NotificationMenuType }

export const MARKETING_EMAILS_MENU = 'Marketing Emails'

export const NOTIFICATION_MENU_LIST: NotificationMenu[] = [
  { name: 'Betting', value: KlaviyoNewsletterPreferences.BETTING },
  { name: 'Fantasy', value: KlaviyoNewsletterPreferences.FANTASY },
  { name: 'College Football CFB', value: KlaviyoNewsletterPreferences.CFB },
  { name: 'Daily Fantasy Sports DFS', value: KlaviyoNewsletterPreferences.DFS },
  { name: 'NFL', value: KlaviyoNewsletterPreferences.NFL },
  { name: 'NFL Draft', value: KlaviyoNewsletterPreferences.NFL_DRAFT },
]

export type NotificationState = {
  [K in KlaviyoNewsletterPreferences]: boolean
}

export enum NotificationActionTypes {
  TOGGLE_MENU = 'toggle_menu',
  RESET_MENUS = 'reset_menus',
}

type NotificationActionType = typeof NotificationActionTypes.TOGGLE_MENU | typeof NotificationActionTypes.RESET_MENUS

export interface NotificationAction {
  type: NotificationActionType
  payload: NotificationMenuType | null
}
